import { Routes, Route } from 'react-router';
import EditAssignment from './EditAssignment';
import Main from '../ManageAssign/Main';
import Assessments from '../Assessments';
import Activities from './Activities';
import Assignment from './Assignments';
import Index from './Index';
import { AssignmentProvider } from '../../context';
import GradeCrQuestions from '../ManageAssign/components/AssignmentResults/CRGrading/gradeCrQuestions';
import MoreActions from '../MoreActions/main';
import CreatePublicAssignment from './CreatePublicAssignment';
import GoogleAccess from '../../../../../src/components/GoogleAccess/index';
import { AssessmentProvider } from '../Assessments/AssessmentContext';
import GradeAssessmentList from '../Assessments/GradeAssessmentList';
import AssessmentGrading from '../Assessments/AssessmentGrading';
import { ActivityProvider } from '../../../activities/context';
import EditActivity from './EditActivity';

const main = () => {
  return (
    <AssignmentProvider>
      <AssessmentProvider>
        <ActivityProvider>
          <Routes>
            <Route path="/" element={<Index />}>
              <Route index element={<Assignment />} />
              <Route path="flashcards/*" element={<Activities /> } />
              <Route path="assessments/*" element={<Assessments />} />
            </Route>
            <Route path=":assignmentId/*" element={<MoreActions />} />
            <Route path=":Id/:activityType?/manage_assign/*" element={<Main />} />
            <Route path=":assignmentId/grade_constructiveResponses" element={<GradeCrQuestions />} />
            <Route path=":Id/edit_assignment/*" element={<EditAssignment />} />
            <Route path="create_public_assignment" element={<CreatePublicAssignment />} />
            <Route path="google_classes" element={<GoogleAccess/>} />
            <Route path="assessments/grade_assessments/*" element={<GradeAssessmentList />} />
            <Route path="assessments/grade_assessments/:Id" element={<AssessmentGrading />} />
            <Route path="flashcards/:Id/edit_activity/*" element={<EditActivity />} />
          </Routes>
        </ActivityProvider>
      </AssessmentProvider>
    </AssignmentProvider>
  );
};

export default main;
